import React from 'react';
import { ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useTranslate } from 'ts/common/hooks';
import { multipleChoiceSeparator } from 'ts/common/questionnaire/common';

interface Props {
    question: SpApi.Client.IQuestionnaireQuestion;
    listMargin?: string;
    listItemMarginLeft?: string;
}

const QuestionnaireReadOnlyResponse: React.FC<Props> = ({
    question,
    listMargin,
    listItemMarginLeft
}) => {
    const t = useTranslate('clientQuestionnaire');

    if (question.responseText === null) {
        return (
            <Text color="gray.400" fontStyle="italic">
                {t('noResponse')}
            </Text>
        );
    }

    if (question.responseType === 'choices_checkboxes') {
        const selections = question.responseText
            .split(multipleChoiceSeparator)
            .filter((selection) => selection.trim() !== '');

        return (
            <UnorderedList margin={listMargin}>
                {selections.map((selection, idx) => (
                    <ListItem key={idx} marginLeft={listItemMarginLeft}>
                        {selection}
                    </ListItem>
                ))}
            </UnorderedList>
        );
    }

    return <Text whiteSpace="pre-wrap">{question.responseText}</Text>;
};

export default QuestionnaireReadOnlyResponse;
